import { FormControlLabel, Switch } from '@mui/material';
import { VectorBasemapStyle } from 'mapbox-gl-esri-sources'
import PropTypes from 'prop-types';
import { useState } from 'react';
import mapConfig from '../config/map.config';

export const mapStyles = [
	{
		title: 'World Topo',
		uri: new VectorBasemapStyle('ArcGIS:Topographic', mapConfig.esriApiKey).styleUrl,
		version: 8,
		sources: {},
		layers: []
	},
	{
		title: 'Satellite',
		uri: new VectorBasemapStyle('ArcGIS:Imagery', mapConfig.esriApiKey).styleUrl,
		version: 8,
		sources: {},
		layers: []
	},
	{
		version: 8,
		sources: {},
		layers: []
	},

];

const MapStyleSwitch = (props) => {
	const [curStyle, setCurStyle] = useState(props.initStyle);

	const switchStyle = (style) => {
		const newStyle = curStyle === 0 ? 1 : 0;
		setCurStyle(newStyle);
		switchMapBasemap(mapStyles[newStyle]);
		props.onSwitch && props.onSwitch(newStyle);
	}

	const switchMapBasemap = async style => {
		if (!style.uri || !props.map) return;
		const map = props.map;


		const response = await fetch(style.uri);
		const responseJson = await response.json();
		const newStyle = responseJson;

		const currentStyle = map.getStyle();
		// if (!currentStyle) return;

		// ensure any sources from the current style are copied across to the new style
		newStyle.sources = Object.assign({},
			currentStyle?.sources || {},
			newStyle.sources
		);

		// find the index of where to insert our layers to retain in the new style
		let labelIndex = newStyle.layers.findIndex((el) => {
			return el.id == 'waterway-label';
		});

		// default to on top
		if (labelIndex === -1) {
			labelIndex = newStyle.layers.length;
		}
		const appLayers = currentStyle ? currentStyle.layers.filter((el) => {
			// app layers are the layers to retain, and these are any layers which have a different source set
			return (
				el.source &&
				el.source != 'mapbox://mapbox.satellite' &&
				el.source != 'mapbox' &&
				el.source != 'composite'
			);
		}) : [];
		newStyle.layers = [
			...newStyle.layers.slice(0, 1),
			...appLayers.slice(1),
		];

		map.setStyle(newStyle);
	}


	return (
		<FormControlLabel
			sx={{ position: 'absolute', bottom: '6px', left: '6px', zIndex: 1 }}
			value="Switch"
			control={<Switch label="switch" checked={!!curStyle} onChange={switchStyle} />}
			label="Satellite Imagery"
			labelPlacement="end"
		/>
	)

}

MapStyleSwitch.propTypes = {
	initStyle: PropTypes.number,
	map: PropTypes.object,
	onSwitch: PropTypes.func
}

MapStyleSwitch.defaultProps = {
	initStyle: 1
}

export default MapStyleSwitch;